// extracted by mini-css-extract-plugin
export var calendar = "Calendar-module--calendar--5b5b0";
export var calendarContainer = "Calendar-module--calendarContainer--20f01";
export var loadingCalendar = "Calendar-module--loadingCalendar--ceea9";
export var loadingIcon = "Calendar-module--loadingIcon--cec6c";
export var loadingLabel = "Calendar-module--loadingLabel--aeb53";
export var rotate = "Calendar-module--rotate--1ca74";